import { Seperator } from "@src/components";
import { Box, FlatList, Text, useTheme } from "@kolmeo/ui-core";
import { BankAccountDetails, BankAccountDetailsResponse } from "@src/types/PaymentPreferences";
import { useTranslation } from "react-i18next";
import PaymentMethodCard from "../ListCards/PaymentMethodCard";
import AddPaymentMethod from "../CardButton";
import { ScreenEmptyState } from "@src/containers";
import { useBranding } from "@src/navigation/useBranding";
import { ButtonV2 } from "@kolmeo/ui-components";
import { useMediaQuery } from "@src/hooks";
import PaymentDetailsHeader from "./PaymentDetailsHeader";
import { useMemo } from "react";

type BankDetailsListProps = {
  data?: BankAccountDetails;
  isBelowMobile: boolean;
  disableAddBankAccounts: boolean;
  onListCardPress: (item: BankAccountDetailsResponse) => void;
  onAddPaymentPress: () => void;
  paymentMethodLabel?: string;
  isAddBankButton?: boolean;
  isHeader?: boolean;
  isInvoices?: boolean;
};
const BankDetailsList = ({
  data,
  disableAddBankAccounts,
  onListCardPress,
  onAddPaymentPress,
  paymentMethodLabel,
  isAddBankButton = false,
  isInvoices,
  isHeader
}: BankDetailsListProps) => {
  const { t } = useTranslation(["Common", "Tenant"]);
  const { spacing, palette } = useTheme();
  const { brandingObject } = useBranding();
  const { isBelowTablet } = useMediaQuery();

  const filteredData = useMemo(() => {
    return data?.bankAccountDetails?.filter((item) => {
      return !(
        (paymentMethodLabel === "Direct Debit" && item?.tags?.includes("debit_now")) ||
        (paymentMethodLabel === "Debit Now" && !item?.tags?.includes("debit_now"))
      );
    });
  }, [data?.bankAccountDetails, paymentMethodLabel]);

  return (
    <>
      {isInvoices && <Seperator margin={spacing.px20} />}
      <FlatList
        ItemSeparatorComponent={() => <Seperator margin={spacing.px8} seperatorColor="transparent" />}
        testID={"bank-details-list"}
        style={{ zIndex: -1 }}
        data={filteredData ?? []}
        ListHeaderComponent={
          <Box>
            <PaymentDetailsHeader paymentMethodLabel={paymentMethodLabel} headlineFlag={isHeader} isInvoices={isInvoices} />
          </Box>
        }
        ListEmptyComponent={<></>}
        renderItem={({ item, index }) => {
          return (
            <PaymentMethodCard
              item={item}
              index={index}
              onPress={() => onListCardPress(item)}
              isFullWidth={isBelowTablet}
              isInvoices={isInvoices}
            />
          );
        }}
        contentContainerStyle={{
          paddingBottom: 6,
          paddingHorizontal: 1,
          flexGrow: 1,
          justifyContent: "center"
        }} // to show renderItem box shadows
        ListFooterComponent={
          <>
            {(paymentMethodLabel !== "Direct Debit" && isAddBankButton) ||
            (!disableAddBankAccounts && data && data?.bankAccountDetails?.length > 0) ? (
              <Box flexDirection="row" alignItems="center">
                <AddPaymentMethod onPress={onAddPaymentPress} text={t("Tenant:PaymentMethods.AddPaymentMethod") as any} icon="plus" />
                <Box flex={1} />
              </Box>
            ) : (
              <></>
            )}
          </>
        }
      />
    </>
  );
};

export default BankDetailsList;
